/* GeneratedContentHash: a4309b6ae394f024d16483e2061e80dd5556209640e749e223185e7bda86d2d6 */
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/

export const PLACEMENT_ID = 'trello-board-screen';
